<template>
    <div class="main-content bg-gradient-cflow">
        <!-- Header -->
        <div class="header d-center col-12 py-5">
            <router-link to="/">
                <img class="logo-login" src="img/brand/logo.png"/>
            </router-link>
        </div>
        <!-- Page content -->
        <div class="container pb-5">
            <transition name="fade" mode="out-in" origin="center top">
                <router-view></router-view>
            </transition>
        </div>
        <footer class="py-5">
            <div class="container">
                <div class="row align-items-center justify-content-xl-between">
                    <div class="col-xl-12">
                        <div class="copyright text-center text-muted">
                            &copy; {{year}} <strong class="text-white">Conect Flow</strong> <span class="text-xl-left text-muted">v. {{versao}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
//   import { SlideYUpTransition } from 'vue2-transitions'
  import config from 'config';

  export default {
    name: 'auth-layout',
    data() {
      return {
        year: new Date().getFullYear(),
        showMenu: false,
        versao: config.app.version
      }
    }
  }
</script>
<style>
.logo-login{
    width: 15rem;
}
</style>
